import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Logo from "../components/Logo";
import { LOGO_AUTH_SECONDARY } from "../config/logoSizes";
const EyeIcon = ({ open }) => open ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg> : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>;
const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [showCpw, setShowCpw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setError(t("minimum8CharsDot"));
      return;
    }
    if (password !== confirm) {
      setError(t("passwordsMatch"));
      return;
    }
    setError("");
    setLoading(true);
    try {
      await axios.post(`/api/auth/reset-password/${token}`, { password });
      setDone(true);
      setTimeout(() => navigate("/signin", { state: { successMsg: t("passwordResetPleaseSignIn") } }), 2500);
    } catch (err) {
      setError(err.response?.data?.message || t("linkInvalidOrExpired"));
    } finally {
      setLoading(false);
    }
  };
  return <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-card">
        <div className="auth-logo-area" onClick={() => navigate("/chat")} style={{ cursor: "pointer" }}>
          <Logo variant="full" size={LOGO_AUTH_SECONDARY} className="auth-logo-img" />
        </div>
        {done ? <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 52, marginBottom: 14 }}>✅</div>
            <h3 style={{ fontFamily: "Outfit,sans-serif", fontSize: 18, fontWeight: 700, color: "var(--accent)", marginBottom: 10 }}>{t("resetSuccessTitle")}</h3>
            <p style={{ fontSize: 13, color: "var(--text-2)" }}>{t("redirectingToSignIn")}</p>
          </div> : <>
            <p className="auth-title">{t("setNewPassword")}</p>
            {error && <div className="form-alert error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">{t("newPassword")}</label>
                <div className="input-wrap-pw">
                  <input
    className="form-input with-eye"
    type={showPw ? "text" : "password"}
    placeholder={t("min8Chars")}
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    autoFocus
  />
                  <button type="button" className="eye-btn" onClick={() => setShowPw(!showPw)}><EyeIcon open={showPw} /></button>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">{t("confirmPassword")}</label>
                <div className="input-wrap-pw">
                  <input
    className="form-input with-eye"
    type={showCpw ? "text" : "password"}
    placeholder={t("confirmPasswordPlaceholder")}
    value={confirm}
    onChange={(e) => setConfirm(e.target.value)}
  />
                  <button type="button" className="eye-btn" onClick={() => setShowCpw(!showCpw)}><EyeIcon open={showCpw} /></button>
                </div>
              </div>
              <button className="btn-primary" type="submit" disabled={loading}>
                {loading ? <><div className="spinner" /> {t("loadingApp")}</> : t("resetPasswordBtn")}
              </button>
            </form>
          </>}
        <div className="auth-foot"><Link to="/signin">{t("backToSignIn")}</Link></div>
      </div>
    </div>;
};
var stdin_default = ResetPassword;
export {
  stdin_default as default
};
